<template>
  <div>
    <el-row>
      <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
        <el-tooltip
          class="item"
          effect="dark"
          content="返回上一级页面"
          placement="bottom-start"
          :disabled="showTooltip"
        >
          <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="12">
        <h3>
          <span v-show="create">新增开票点收费项目</span>
        </h3>
      </el-col>
    </el-row>
    <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
    <div style="max-width: 800px">
      <el-form
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="180px"
        v-loading="showLoading"
      >
        <!-- <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开票单位名称">{{this.form.agencyName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票单位编码">{{this.form.agencyCode}}</el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开票点名称">{{this.form.placeName}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票点编码">{{this.form.placeCode}}</el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="收费项目名称" prop="itemCode">
              <el-select 
                v-if="create"
                v-model="form.itemCode"
                placeholder="请选择项目"
                @change="changeItem"
                style="width:100%"
              >
                <el-option
                  v-for="item in itemOptions"
                  :key="item.itemCode"
                  :label="item.itemName"
                  :value="item.itemCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="收费项目编码">{{this.form.itemCode}}</el-form-item>
          </el-col> -->
        </el-row>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

let _kits, _form;
export default {
  props: ["entity"],
  components: {},
  data() {
    let create = true; //this.entity.creat;
    let form = {
      agencyName: this.entity.agencyName,
      agencyCode: this.entity.agencyCode,
      placeCode: this.entity.placeCode,
      placeName: this.entity.placeName,
      itemCode: "",
      itemName: "",
      updateMode: "1"
    };
    let data = {
      showLoading: true,
      showTooltip: false,
      showBtnLoading: false,
      create,
      form,
      formRules: {
        itemCode: [
          {
            required: true,
            message: "请选择收费项目",
            trigger: "blur"
          }
        ]
      },
      itemOptions: []
    };
    return data;
  },
  methods: {
    onBack() {
      this.$emit("back");
    },
    onSave() {
      _form.submit();
    },
    changeItem() {
      if (this.itemOptions && this.itemOptions.length > 0) {
        for (var i = 0; i < this.itemOptions.length; i++) {
          if (this.form.itemCode == this.itemOptions[i].itemCode) {
            this.form.itemName = this.itemOptions[i].itemName;
            break;
          }
        }
      }
    },
    //查询开票单位收费项目
    queryItem() {
      _kits.api.call(
        "QUERYAGENCYITEMMINUSLIST",
        {
          agencyCode: this.form.agencyCode,
          placeCode: this.form.placeCode
        },
        result => {
          if (result.returnCode == "0000") {
            let data = result.data;
            if (result.data && result.data.length > 0) {
              if (this.entity.typeList) {
                for (var i = data.length - 1; i >= 0; i--) {
                  var itemCode = data[i].itemCode;
                  if (
                    this.entity.typeList.indexOf("," + itemCode + ",") != -1
                  ) {
                    data.splice(i, 1);
                  }
                }
              }
              this.itemOptions = data;
            }
            // else {
            //   this.$message.error("没有查询到此开票单位的收费项目列表信息");
            // }
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    }
  },
  created() {
    _kits = this.$kits();
    if (!this.create) {
      _kits.api.call(
        "GETAGENCYPLACEITEM",
        {
          agencyCode: this.entity.agencyCode,
          placeCode: this.entity.placeCode,
          itemCode: this.entity.itemCode
        },
        result => {
          if (result.returnCode == "0000") {
            this.form = result.data;
            this.queryItem();
          } else {
            this.$message.error(result.returnMsg);
          }
        }
      );
    } else {
      this.queryItem();
    }
  },
  mounted() {
    _form = _kits.control.getStandardForm({
      name: "form",
      api: "SAVEAGENCYPLACEITEM"
    });
    //*
    setTimeout(() => {
      _kits.page.foucus("ipt01");
      this.showLoading = false;
      this.showTooltip = true;
    }, 300);
    //*/
  }
};
</script>
